import React, { memo } from 'react';

import type { SectionViewModel } from '../../viewmodels/createSectionViewModel';
import { QuestionTable } from '../questions/QuestionTable';
import { SectionHeader } from './SectionHeader';

import styles from './SectionAccordion.scss';

type Props = {
  viewModel: SectionViewModel;
};

export const SectionAccordion = memo(function SectionAccordion({
  viewModel,
}: Props) {
  return (
    <section className={styles.accordion} data-test="section">
      <SectionHeader viewModel={viewModel} />
      {viewModel.isExpanded && <QuestionTable viewModel={viewModel} />}
    </section>
  );
});
